// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__gB1jQ","children":"Layout_children__OtWug"};